
const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-run-line',
      title: 'スポーツ障害',
      description: '捻挫、肉離れ、疲労骨折など、スポーツによる怪我の診断と治療を行います。早期復帰をサポートします。',
    },
    {
      icon: 'ri-user-line',
      title: '関節痛治療',
      description: '膝、肩、股関節などの痛みに対し、適切な診断と治療を提供。変形性関節症にも対応します。',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '腰痛・肩こり',
      description: '慢性的な腰痛や肩こりの原因を特定し、物理療法やリハビリで症状の改善を目指します。',
    },
    {
      icon: 'ri-hand-heart-line',
      title: '骨折・外傷',
      description: '骨折や打撲などの外傷に対し、迅速な診断と適切な治療を行います。ギプス固定にも対応。',
    },
    {
      icon: 'ri-wheelchair-line',
      title: 'リハビリテーション',
      description: '理学療法士による専門的なリハビリで、機能回復と痛みの軽減をサポートします。',
    },
    {
      icon: 'ri-stethoscope-line',
      title: '骨粗鬆症検査',
      description: '骨密度測定により骨粗鬆症のリスクを評価し、予防と治療のアドバイスを行います。',
    },
  ];

  return (
    <section className="py-20 lg:py-32 bg-blue-50/50 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
            診療内容
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 lg:p-10 hover:shadow-xl transition-all hover:-translate-y-1"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-5xl text-[#007bbb]`}></i>
              </div>
              <h3 className="text-xl md:text-2xl font-semibold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
